import GenderEntry from './GenderEntry';

export default GenderEntry;
